import CloudSVG from '../../../svgs/CloudSVG';
import SdkSVG from '../../../svgs/SdkSVG';
import HistorySVG from '../../../svgs/HistorySVG';
import PropTypes from 'prop-types';
import GlobeSVG from '../../../svgs/GlobeSVG';
import PersonSVG from '../../../svgs/PersonSVG';

export const IconPicker = ({ icon }) => {
  return (
    <>
      {icon === 'cloud' ? <CloudSVG /> : null}
      {icon === 'sdk' ? <SdkSVG /> : null}
      {icon === 'history' ? <HistorySVG /> : null}
      {icon === 'globe' ? <GlobeSVG /> : null}
      {icon === 'person' ? <PersonSVG /> : null}
    </>
  );
};

IconPicker.propTypes = {
  icon: PropTypes.string.isRequired
};

export default IconPicker;
